import { useLazyQuery } from "@apollo/client";
import { CHECK_INVITE_CODE_EXISTS } from "../gql";

interface CheckInviteCodeExistsVariables {
  connectionCode: string;
}

interface CheckInviteCodeExistsResponse {
  connections: {
    nodes: Array<{ connectionCode: string } | null>;
  };
}

export function useCheckInviteCodeExists() {
  const [checkCode, { data, loading, error }] = useLazyQuery<
    CheckInviteCodeExistsResponse,
    CheckInviteCodeExistsVariables
  >(CHECK_INVITE_CODE_EXISTS, {
    fetchPolicy: "network-only", // Always check server
  });

  const checkInviteCodeExists = async (
    connectionCode: string,
  ): Promise<boolean> => {
    if (!connectionCode) return false;

    try {
      const result = await checkCode({
        variables: { connectionCode },
      });

      const nodes = result.data?.connections?.nodes || [];
      return nodes.length > 0 && nodes[0] !== null;
    } catch (err) {
      console.error("Error checking invite code:", err);
      return false;
    }
  };

  return {
    checkInviteCodeExists,
    loading,
    error,
  };
}
